import React, { useState } from 'react';
import { useGlobalContext } from "../../GlobalContext";
import HarianNeraca from './pdf/harianneraca';

const LaporanNeraca = () => {
  const { bulan, api } = useGlobalContext();
  const Tahunaktif = new Date().getFullYear();
  const tahunterakhir = Array.from({ length: 3 }, (_, i) => Tahunaktif - i);
  const [selectedBulan, setSelectedBulan] = useState(0);  
  const [selectedYear, setSelectedYear] = useState(tahunterakhir[0]);
  const [type, setType] = useState('B');
  const [loading, setLoading] = useState(false);
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    const bulanNumber = (selectedBulan + 1).toString().padStart(2, '0');
    const periode = `${selectedYear}${bulanNumber}`;
    const namaBulan = bulan[selectedBulan] || "Tidak Diketahui";
    const tahun = selectedYear;

    setLoading(true);

    try {
      // endpoint sesuai tipe
      const endpoints = {
        'B': `api/akuntansi/neraca/${periode}`,           // endpoint bulanan
        'A': `api/akuntansi/akumulasineraca/${periode}`   // endpoint akumulasi
      };

      const endpoint = endpoints[type] || endpoints.B;
      let response=[];

      if(type==='A'){
        const periode01 = `${selectedYear}01`;
        const periodesd = periode;
        const resPerkiraan = await api.get(`api/akuntansi/perkiraan`);
        const resSaldoAwal = await api.get(`api/akuntansi/getsaldoawaltahun/${periode01}`);
        const resMutasi = await api.get(`api/akuntansi/getmutasisdperiode/${periodesd}`);
        
        const dataPerkiraan = resPerkiraan.data || [];
        const dataSaldoAwal = resSaldoAwal.data || [];
        const dataMutasi = resMutasi.data || [];
        
        console.log('Perkiraan:', dataPerkiraan);
        console.log('Saldo Awal:', dataSaldoAwal);
        console.log('Mutasi:', dataMutasi);
        
        // Gabungkan data dari 3 sumber seperti konsep Potongan.js
        response = dataPerkiraan.map(perk => {
          const saldoAwalData = dataSaldoAwal.find(s => s.kdperk === perk.kdperk);
          const mutasiData = dataMutasi.find(m => m.kdperk === perk.kdperk);
          
          const awaldb = saldoAwalData ? parseFloat(saldoAwalData.awaldb || 0) : 0;
          const awalkd = saldoAwalData ? parseFloat(saldoAwalData.awalkd || 0) : 0;
          const mutasidb = mutasiData ? parseFloat(mutasiData.mutasidb || 0) : 0;
          const mutasikd = mutasiData ? parseFloat(mutasiData.mutasikd || 0) : 0;
          
          let saldo = 0;
          if(perk.posisi === 'D') {
            saldo = awaldb - awalkd + mutasidb - mutasikd;
          } else {
            saldo = awalkd - awaldb + mutasikd - mutasidb;
          }
          
          const recordNeraca = {
            kdperk: perk.kdperk,
            keterangan: perk.keterangan,
            posisi: perk.posisi,
            penbia: perk.penbia,
            awaldb: awaldb,
            awalkd: awalkd,
            mutasidb: mutasidb,
            mutasikd: mutasikd,
            saldo: saldo
          };
          
          return recordNeraca;
          
        }).sort((a, b) => {
          return parseInt(a.kdperk) - parseInt(b.kdperk);
        });
        
        console.log('Data Gabungan:', response);
        
        // Cetak langsung untuk type A
        if (Array.isArray(response) && response.length > 0) {
          HarianNeraca(response, namaBulan, tahun);
          setLoading(false);
          return;
        } else {
          alert(`Data tidak ditemukan untuk periode ${periode}.`);
          setLoading(false);
          return;
        }
      }
      if(type==='B'){
        response = await api.get(endpoint);
        console.log(response);
      }
      //const response = await api.get(endpoint);

      if (response.status !== 200) {
        alert(`Server Error`);
        setLoading(false);
        return;
      }

      const result = response.data;
      if (!Array.isArray(result) || result.length === 0) {
        alert(`Data tidak ditemukan untuk periode ${periode}.`);
      } else {
        // Cetak PDF neraca
        HarianNeraca(result, namaBulan, tahun);
      }
    } catch (error) {
      console.error('Gagal mengambil data:', error);
      alert(`Terjadi kesalahan saat mengambil data: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="row">
        <div className="col-md-12">
          <div className="card card-info" style={{ width: '400px' }}>
            <div className="card-header">
              <h5 className="card-title">Laporan Neraca</h5>
            </div>
            <form className="form-horizontal" onSubmit={handleSubmit}>
              <div className="card-body">  
                <div className="form-group row mb-1">
                  <label className="col-sm-3 col-form-label">Model</label>
                  <div className="col-sm-6">
                    <select
                      className="form-control"
                      value={type}
                      onChange={(e) =>setType(e.target.value)}
                    >       
                      <option value="B">Bulanan</option>
                      <option value="A">Akumulasi</option>               
                    </select>
                  </div>
                </div>
                <div className="form-group row mb-1">
                  <label className="col-sm-3 col-form-label">Periode</label>
                  <div className="col-sm-5">
                    <select
                      className="form-control"
                      value={selectedBulan}
                      onChange={(e) => setSelectedBulan(parseInt(e.target.value))}
                    >
                      {bulan.map((item, index) => (
                        <option key={index} value={index}>{item}</option>
                      ))}
                    </select>
                  </div>  
                  <div className="col-sm-4">
                    <select
                      className="form-control"
                      value={selectedYear}
                      onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                    >
                      {tahunterakhir.map((year) => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </select>
                  </div>       
                </div>
              </div>
              <div className="modal-footer pt-1">
                <button
                  type="submit"
                  className="btn btn-sm btn-primary"
                  disabled={loading}
                >
                  {loading ? 'Memproses...' : 'Cetak'}
                </button>
              </div>
            </form>  
          </div>
        </div>
      </div>
    </div>
  );
};

export default LaporanNeraca;
